import { Component } from "@angular/core";
import { XOField } from './xo-field.component';

@Component({
    selector: "xo-field-boolean",
    templateUrl: "./xo-field-boolean.component.html"
})
export class XOFieldBoolean extends XOField {
}
